import { useUsersCurrentAccessesQuery } from '@/api/queries/users';
import { countryOriginOptions } from '../constants';

const countryToTimezone: Record<(typeof countryOriginOptions)[number], string> = {
  EE: 'Europe/Tallinn', // Estonia
  LV: 'Europe/Riga', // Latvia
  GB: 'Europe/London', // United Kingdom
};

function getTimezoneFromCountryCode(
  code: (typeof countryOriginOptions)[number]
): string | undefined {
  return countryToTimezone[code];
}

// TODO: Convert this to use /countries/{countryCode}/conf
const useOperatorTimezone = () => {
  const { data: userInfo } = useUsersCurrentAccessesQuery();

  const country = userInfo?.country ?? 'EE';

  const determinedTimezone = getTimezoneFromCountryCode(
    country as (typeof countryOriginOptions)[number]
  );
  if (!determinedTimezone) return countryToTimezone.EE;

  return determinedTimezone;
};

export default useOperatorTimezone;
